import { t as getFixedT } from "@/i18n";
import type { SupportedLanguage } from "@/lib/site";
import "./Programs.css";

interface ProgramsProps {
  lang: SupportedLanguage;
}

/**
 * #programs — 09-landing-page.md §2, a quick-scan chip row of the academic tracks offered.
 * Deliberately marketing copy (broad stage names), not a literal render of the `grades` lookup
 * table used by the form's select (§6 "feeds gradeInterested familiarity" — primes the visitor
 * before they reach the form, doesn't need to be the exact same 14-row list).
 */
export function Programs({ lang }: ProgramsProps) {
  const t = getFixedT(lang);
  const chips = t("programs.chips", { returnObjects: true }) as string[];

  return (
    <section
      id="programs"
      className="fa-programs"
      aria-labelledby="programs-heading"
    >
      <div className="fa-section-inner">
        <h2 id="programs-heading" className="fa-section-heading">
          {t("programs.heading")}
        </h2>
        <p className="fa-programs__intro">{t("programs.intro")}</p>
        <ul className="fa-programs__chips">
          {chips.map((chip) => (
            <li key={chip} className="fa-programs__chip">
              {chip}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
